export const TAX_TYPES = ["VAT", "GST", "SALES_TAX", "SERVICE_TAX", "CUSTOM", "EXCISE"];
export const CALCULATION_TYPES = ["PERCENTAGE"/* , "FIXED_AMOUNT" */];
export const APPLICABLE_ON = ["SALES", "PURCHASE", "BOTH"];
export const TAX_SCOPE = ["PRODUCT", "SERVICE", "ALL"];
export const INCLUSIVE_TYPE = ["INCLUSIVE", "EXCLUSIVE"];
export const TAX_GROUP = ["STATE", "CENTRAL", "LOCAL", "INTERNATIONAL"];